import React, { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import {
  LanguageCodeType,
  SUPPORT_LANGUAGE_CODE_LIST,
} from "../../constant/constant";
import { setLanguageCode } from "../../redux/slices/masterSlice";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";

function LanguageRoute() {
  const { i18n } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    let processedLanguageCode: LanguageCodeType | "" = "";
    if (
      params.languageCode &&
      SUPPORT_LANGUAGE_CODE_LIST.includes(
        params.languageCode as LanguageCodeType
      )
    ) {
      processedLanguageCode = params.languageCode as LanguageCodeType;
    }

    i18n
      .changeLanguage(processedLanguageCode)
      .then()
      .catch((err) => console.error(err));
    dispatch(setLanguageCode(processedLanguageCode));
  }, [params.languageCode]);

  return <Outlet />;
}

export default LanguageRoute;
